export default __webpack_public_path__ + "static/media/2-2.e8b58132.webp";